/**
 * Canonical time-range options and default for every conversation list surface.
 *
 * These lived as literals in four different files, which is how the Inbox came
 * to initialise at "30d" while its own "filters modified" dot compared against
 * "7d" — so the dot was lit on first paint with nothing modified. Import from
 * here instead of retyping the string.
 *
 * Note: a "7d" literal elsewhere in the codebase is not necessarily a default.
 * The conversation detail rail's "This week" card and column genuinely mean a
 * seven day window and must keep their own literal.
 */

export interface ConversationTimeRangeOption {
  value: string;
  label: string;
}

export const CONVERSATION_TIME_RANGE_OPTIONS: ConversationTimeRangeOption[] = [
  { value: "1h", label: "Last Hour" },
  { value: "24h", label: "Last 24 Hours" },
  { value: "7d", label: "Last 7 Days" },
  { value: "30d", label: "Last 30 Days" },
  { value: "90d", label: "Last 90 Days" },
  { value: "all", label: "All Time" },
];

/** The window a conversation list opens on when the user has chosen nothing. */
export const DEFAULT_CONVERSATION_TIME_RANGE = "30d";
